import { Environment } from './Environment';
import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global/Container';
import { ISharepointNewsResult } from '../interfaces/ISharepointNews';

export default class SharepointService {

  public static getNewsFromSite(environment: "Development" | "Test" | "Production", tenantName: string, siteName: string, skip: number, take: number): Promise<ISharepointNewsResult> {
    return new Promise<ISharepointNewsResult>((resolve: (result: ISharepointNewsResult) => void): void => {
      const apiUrl = Environment.getEnvironmentForMessagesAPI(environment);
      new FetchProxy(`${apiUrl}/${tenantName}/sharepoint-news/${siteName}?skip=${skip}&take=${take}`, {
        method: "GET"
      })
        .withContainer(sdkContainerInstance)
        .fetch()
        .then((response) => {
          if (!response.ok) {
            resolve(null);
            return;
          }
          return response.json();
        })
        .then((newsResult) => {
          resolve(newsResult);
        })
        .catch(error => {
          console.log(error);
          resolve(undefined);
        });
    });
  }
}